"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.targetIncludesAny = void 0;
function targetIncludesAny(target, options) {
    return options.some(function (option) { return target.includes(option); });
}
exports.targetIncludesAny = targetIncludesAny;
